import React  from 'react'
import { Form, Input,  Button, Space} from 'antd';
import GetUserDept from '../../cpn/GetUserDept';
function UserQuery(props) {   
    const [form] = Form.useForm();
    return (
        <Form
            name="basic"
            layout='inline'
            initialValues={{remember: true,eu_name:'',eu_ba_phone:'',eu_state:'',ed_id:''}}
            autoComplete="off"
            form={form}
            onFinish={() => {
                form
                    .validateFields()
                    .then((values) => {
                        props.getUserQuery(values);
                    })
                    .catch((info) => {
                        console.log('Validate Failed:', info);
                    });
            }}
        >
             <GetUserDept 
                label='部门' 
                wrapperCol={{span:17}}
                getUserDept={(e) => {}}
                name='ed_id'
                style={{width:"180px"}}
                setDept={true}
                FormStyle={{width:"200px"}}
            />
            <Form.Item
                label="姓名"
                name="eu_name"
                labelCol={{span:8}}
                wrapperCol={{span: 14}}
            >
                <Input onChange={() => {}} />
            </Form.Item>
            <Form.Item
                label="登录手机"
                name="eu_ba_phone" 
                labelCol={{span:6}}                                   
                wrapperCol={{span: 16}}
            >
                <Input onChange={() => {}} />
            </Form.Item>                
            <Form.Item>
                <Space>
                    <Button
                        htmlType='submit'
                    >
                        查询
                    </Button>
                    <Button onClick={() => { 
                        form.resetFields();
                        props.getUserQuery({
                            e_id:localStorage.getItem('e_id'),
                            ed_id:'',
                            eu_name:'',
                            eu_ba_phone:'',
                            eu_state:'1'
                        })              
                        }}>重置</Button>
                </Space>
            </Form.Item>             
        </Form>
    )
}

export default UserQuery